/** CoStar.Api.AptsNet.Aggregate.ViewModels.AddListing.AddListingStatus */
export var AddListingStatus;
(function (AddListingStatus) {
    AddListingStatus[AddListingStatus["Unknown"] = 0] = "Unknown";
    AddListingStatus[AddListingStatus["Active"] = 1] = "Active";
    AddListingStatus[AddListingStatus["Pending"] = 2] = "Pending";
    AddListingStatus[AddListingStatus["OffMarket"] = 3] = "OffMarket";
    AddListingStatus[AddListingStatus["Terminate"] = 4] = "Terminate";
    AddListingStatus[AddListingStatus["SubscriptionHold"] = 5] = "SubscriptionHold";
    AddListingStatus[AddListingStatus["Unpublished"] = 6] = "Unpublished";
    AddListingStatus[AddListingStatus["AwaitingVerification"] = 7] = "AwaitingVerification";
    AddListingStatus[AddListingStatus["UserDeleted"] = 8] = "UserDeleted";
})(AddListingStatus || (AddListingStatus = {}));
/** CoStar.Api.AptsNet.Aggregate.ViewModels.AddListing.AddListingReasonCode */
export var AddListingReasonCode;
(function (AddListingReasonCode) {
    AddListingReasonCode[AddListingReasonCode["None"] = 0] = "None";
    AddListingReasonCode[AddListingReasonCode["SubletPaidListing"] = 10] = "SubletPaidListing";
    AddListingReasonCode[AddListingReasonCode["DuplicateListingSameUser"] = 12] = "DuplicateListingSameUser";
    AddListingReasonCode[AddListingReasonCode["Other"] = 13] = "Other";
    AddListingReasonCode[AddListingReasonCode["FairHousingViolation"] = 20] = "FairHousingViolation";
    AddListingReasonCode[AddListingReasonCode["DuplicateListingDifferentUser"] = 53] = "DuplicateListingDifferentUser";
    AddListingReasonCode[AddListingReasonCode["InvalidAddressRejected"] = 54] = "InvalidAddressRejected";
    AddListingReasonCode[AddListingReasonCode["WatermarkOnPhoto"] = 55] = "WatermarkOnPhoto";
    AddListingReasonCode[AddListingReasonCode["PhotoNotOfListing"] = 56] = "PhotoNotOfListing";
    AddListingReasonCode[AddListingReasonCode["NotFixedLocation"] = 57] = "NotFixedLocation";
    AddListingReasonCode[AddListingReasonCode["IdentifiablePersonInPhoto"] = 58] = "IdentifiablePersonInPhoto";
    AddListingReasonCode[AddListingReasonCode["OffMarket"] = 60] = "OffMarket";
})(AddListingReasonCode || (AddListingReasonCode = {}));
/** CoStar.Api.AptsNet.Aggregate.ViewModels.AddListing.AddListingVerificationStatus */
export var AddListingVerificationStatus;
(function (AddListingVerificationStatus) {
    AddListingVerificationStatus[AddListingVerificationStatus["None"] = 0] = "None";
    AddListingVerificationStatus[AddListingVerificationStatus["Approved"] = 1] = "Approved";
    AddListingVerificationStatus[AddListingVerificationStatus["Rejected"] = 2] = "Rejected";
    AddListingVerificationStatus[AddListingVerificationStatus["Suspicious"] = 3] = "Suspicious";
    AddListingVerificationStatus[AddListingVerificationStatus["Pending"] = 4] = "Pending";
    AddListingVerificationStatus[AddListingVerificationStatus["Obsolete"] = 5] = "Obsolete";
    AddListingVerificationStatus[AddListingVerificationStatus["Skipped"] = 6] = "Skipped";
})(AddListingVerificationStatus || (AddListingVerificationStatus = {}));
/** CoStar.Api.AptsNet.Aggregate.ViewModels.AddListing.TrustedResult */
export var TrustedResult;
(function (TrustedResult) {
    TrustedResult[TrustedResult["None"] = 0] = "None";
    TrustedResult[TrustedResult["NotTrusted"] = 1] = "NotTrusted";
    TrustedResult[TrustedResult["FullyTrusted"] = 2] = "FullyTrusted";
})(TrustedResult || (TrustedResult = {}));
